// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-hot-loader/index.js!../../../../mini-css-extract-plugin/dist/loader.js!../../../../css-loader/dist/cjs.js!../../../../vue-loader/lib/loaders/stylePostLoader.js!../../../../sass-loader/dist/cjs.js!../../../../vue-loader/lib/index.js??vue-loader-options!./News.vue?vue&type=style&index=0&id=51c6fa30&prod&lang=scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("8b705092", content, true, {});